module.exports = __webpack_public_path__ + "media/images/associate_job_lead_sp-14f09e645c84d1d022c51e313ffac27d.png";